module.exports = __webpack_public_path__ + "img/elecciones20213.566ab7cb.jpg";